(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function getFooterSrc() {
    const drawer = document.querySelector('header-drawer[data-nr-mobile-menu-footer-src]');
    return drawer ? drawer.dataset.nrMobileMenuFooterSrc : '';
  }

  function preloadFooterImage() {
    const src = getFooterSrc();
    if (!src) return;

    const existing = document.querySelector('link[data-nr-mobile-menu-footer-preload]');
    if (existing && existing.getAttribute('href') === src) return;

    if (existing) existing.remove();

    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    link.setAttribute('data-nr-mobile-menu-footer-preload', '');
    document.head.appendChild(link);

    const img = new Image();
    img.src = src;
  }

  function maybePreload() {
    if (mobileQuery.matches) preloadFooterImage();
  }

  maybePreload();
  mobileQuery.addEventListener('change', function (event) {
    if (event.matches) preloadFooterImage();
  });

  const menuContainer = document.getElementById('Details-menu-drawer-container');
  const menuButton = menuContainer ? menuContainer.querySelector('summary') : null;

  if (menuButton) {
    menuButton.addEventListener('touchstart', preloadFooterImage, { passive: true });
    menuButton.addEventListener('mouseenter', preloadFooterImage);
  }
})();
